<a [hidden]="!showBack"
   [href]="backLinkUrl"
   id="backLink"
   class="badge back-button"
   (click)="goBack($event)"
   data-toggle="tooltip"
   title="{{'BACK_TOOLTIP' | translate}}"
   tabindex="0">
  <span class="bi bi-chevron-left d-inline-block"></span>
  <span class="d-none d-sm-none d-md-inline-block" translate="BACK"></span>
</a>
